document.addEventListener('turbolinks:load', function () {
    if ($('.v2_permit_applications-form-section').length === 0) {
        return false
    }

    $(document).on('keyup', '.search-permit', function() {
        var department = $(this).attr('id')
        var departmentWiseSection = $(`#departmentWiseSection-${department}`)
        var filter = $(this).val().toLowerCase();
        $(departmentWiseSection).find(".search-by").each(function () {
            var searchBy = $(this).text().toLowerCase()

            var matchedFilter = searchBy.includes(filter)
            var permitSection = $(this).parents('.permit-section')
            var permitCard = $(this).parents('.permit-card')

            if ($(permitSection).hasClass('with-parent-category')) {
                $(permitSection).toggle(matchedFilter);

                var visibleCount = $(permitCard).find('.permit-section').filter(function () {
                    return $(this).css('display') !== 'none';
                }).length;

                if (visibleCount === 0) {
                    $(permitCard).toggle(false);
                } else if(matchedFilter) {
                    $(permitCard).toggle(true);
                }

                if (filter.length > 0 && matchedFilter) {
                    toggleSubCategory(permitCard, true);
                }
            } else {
                $(permitCard).toggle(matchedFilter);
            }
        });

        if (filter.length === 0) {
            // Close only the sub-categories that the search opened
            $(departmentWiseSection).find('.accordion-collapse[data-search-opened="true"]').each(function () {
                toggleSubCategory($(this).closest('.permit-card'), false);
            });
        }

        var clearBtn = $(this).parents().find("#clear-btn")
        // Show clear button if input is not empty
        $(clearBtn).toggle(filter.length > 0);

        triggerClearEvent(clearBtn)
    })

    function toggleSubCategory(permitCard, open) {
        var collapse = $(permitCard).find('> .accordion-collapse')
        if (collapse.length === 0) return

        var isOpen = collapse.hasClass('show')
        if (open === isOpen) return

        // Only auto-close what the search auto-opened, never what the user opened
        if (open) {
            collapse.attr('data-search-opened', 'true')
        } else {
            collapse.removeAttr('data-search-opened')
        }

        collapse.toggleClass('show', open)
        $(permitCard).find('> .accordion-header .accordion-button')
            .toggleClass('collapsed', !open)
            .attr('aria-expanded', open)

        if (open) {
            collapse[0].dispatchEvent(new CustomEvent('shown.bs.collapse', { bubbles: true }))
        }
    }

    function triggerClearEvent(clearBtn) {
        $(clearBtn).on("click", function (e) {
            e.preventDefault()
            $(this).parents().find('.search-permit').val("").trigger("keyup"); // Clears input and triggers search reset
        });
    }
});